import { z } from 'zod';
import { requiredText, textWithinLimit } from '@/shared/lib/validation';

/** Проверяет комментарий и выбор штрафа при снятии исполнителя */
export const removeExecutorSchema = z.object({
    comment: requiredText('Комментарий', 'Оставьте комментарий')
        .pipe(textWithinLimit(255, 'Комментарий не должен превышать 255 символов')),
    hasPenalty: z.boolean(),
});

export type RemoveExecutorFormValues = z.infer<typeof removeExecutorSchema>;

export const REMOVE_EXECUTOR_DEFAULTS: RemoveExecutorFormValues = {
    comment: '',
    hasPenalty: false,
};
